import {Basic} from 'types'
import {areUnitCountersEqual} from 'utils/guestCounterHelpers'
import {StepOrder} from '../../types'
import {getMonth} from './utils'

export const setMonth = (userInput: Basic.CartItemInput, month: string, stepOrder: StepOrder): Basic.CartItemInput => {
  return {...userInput, month}
}

export const setOptionId = (
  userInput: Basic.CartItemInput,
  optionId: string,
  stepOrder: StepOrder
): Basic.CartItemInput => {
  return stepOrder === 'guestsFirst'
    ? {...userInput, optionId, availabilityId: ''}
    : {...userInput, optionId, unitCounters: {}, date: '', month: getMonth(), availabilityId: ''}
}

export const setDate = (userInput: Basic.CartItemInput, date: string, stepOrder: StepOrder): Basic.CartItemInput => {
  return stepOrder === 'guestsFirst'
    ? {...userInput, date, optionId: '', availabilityId: ''}
    : {...userInput, date, availabilityId: ''}
}

export const setUnitCounters = (
  userInput: Basic.CartItemInput,
  unitCounters: Basic.UnitCounterMap,
  stepOrder: StepOrder
): Basic.CartItemInput => {
  // Only reset date if unit counters have changed
  const hasChanged = !areUnitCountersEqual(userInput.unitCounters, unitCounters)

  if (!hasChanged) {
    return {...userInput, unitCounters}
  }

  return stepOrder === 'guestsFirst'
    ? {...userInput, unitCounters, date: '', month: getMonth(), availabilityId: '', optionId: ''}
    : {...userInput, unitCounters, date: '', month: getMonth(), availabilityId: ''}
}

export const setAvailabilityId = (
  userInput: Basic.CartItemInput,
  availabilityId: string,
  stepOrder: StepOrder
): Basic.CartItemInput => {
  return {...userInput, availabilityId}
}
